/* global MatgenGlobal */

import { init as tableInit } from './m4c-table/table-events.js';
import { init as editorInit } from './matgen-ui/client/events/editor-events.js';
import { init as commonInit } from './matgen-ui/client/events/common-events.js';
import { v4 as UUID } from 'uuid';
import * as Tables from './m4c-table/tables';
import MatgenUIFunctions from './matgen-ui/ui-functions.js';
import { emit } from './matgen-ui/common/helpers.js';

const InitMatgenEditor = () => {
  MatgenGlobal.UUID = UUID;
  MatgenGlobal.Tables = Tables;
  MatgenGlobal.DynamicForms = {};
  MatgenGlobal.MatgenUIFunctions = MatgenUIFunctions;

  MatgenGlobal.EditorInit = editorInit;
  MatgenGlobal.TableInit = tableInit;
  MatgenGlobal.CommonInit = commonInit;

  MatgenGlobal.EditorInit();
  MatgenGlobal.TableInit();
  MatgenGlobal.CommonInit();
  emit({
    event: 'matgen-editor-init-complete',
  });
};

export default InitMatgenEditor;
